// Copyright 2026. WebPros International GmbH. All rights reserved.

export const OS_IMAGES = {
    TOOLBAR: 'osImages-toolbar',
    TABLE: 'osImages-table',
    VISIBILITY: 'osImages-visibility',
    DEFAULT: 'osImages-default',
    BATCH_DELETE_BTN: 'osImages-batch-delete',
};
